import styles from './Projects.module.css'
import { useNavigate } from 'react-router-dom'

import UoMe from './UoMeImage.webp'
import WAM from './WatAMomentImage.webp'
import MMC from './MathClubImage.webp'
import BIC from './BICImage.webp'
import LaTalk from './LaTalkImage.webp'
import PocketPhysio from './PocketPhysioImage.webp'

export default function Projects() {
    return (
        <>
            <div className={styles.pageContainer}>
                <ExitButton />
                <div className={styles.scrollSpace}>
                    <h1 className={styles.title}>PROJECTS</h1>

                    <div className={styles.projectContainer}>
                        <div className={styles.projectImg}>
                            <img src={PocketPhysio} alt="PocketPhysio"></img>
                        </div>
                        <div className={styles.projectCaption}>
                            <h2>Pocket Physio</h2>
                            <div className={styles.dtContainer}>
                                <h3>TypeScript, React, MediaPipe, NestJS, PostgreSQL</h3>
                                <h4>Aug 2026</h4>
                            </div>
                            <p>Pocket Physio is a web-based physical therapy platform that tracks joint angles and exercise biomechanics entirely in the browser. Powered by client-side MediaPipe pose estimation, it measures real-time range of motion, rep counts, and trunk lean to provide color-coded clinical feedback during rehabilitation. It logs session history and adherence metrics. I am currently hardening edge-case tracking with OpenCV optical flow to handle self-occlusions during floor exercises.</p>
                            <a href="https://github.com/cherrybyproxy/pocket-physio" target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                    </div>

                    <div className={styles.projectContainer}>
                        <div className={styles.projectImg}>
                            <img src={LaTalk} alt="LaTalk"></img>
                        </div>
                        <div className={styles.projectCaption}>
                            <h2>LaTalk</h2>
                            <div className={styles.dtContainer}>
                                <h3>Python, SSE-Starlette, Flask, React, JavaScript, HTML/CSS</h3>
                                <h4>Sept 2025</h4>
                            </div>
                            <p>LaTalk is a full-stack React web app that translates recorded speech into LaTeX in real time. It integrates AI-driven annotation to fill in missing context and skipped steps, while asynchronous programming ensures low-latency performance. The system also features native smart glasses integration, displaying custom graphics directly on screen to create an immersive and interactive note-taking experience.</p>
                            <a href="https://github.com/the-Fish2/LaTalk" target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                    </div>

                    <div className={styles.projectContainer}>
                        <div className={styles.projectImg}>
                            <img src={UoMe} alt="UoMe"></img>
                        </div>
                        <div className={styles.projectCaption}>
                            <h2>UoMe</h2>
                            <div className={styles.dtContainer}>
                                <h3>Python, Flask, React Native, TypeScript, HTML/CSS</h3>
                                <h4>Jan 2025</h4>
                            </div>
                            <p>UoMe is a debt-tracking app designed to simplify group expense management. Whether it's splitting dinner with friends or organizing a group trip, UoMe keeps track of who owes what with ease. The app features secure account management, automated expense logging from receipts, and a clean, mobile-friendly interface. With a dashboard for quick insights, detailed transaction history, and visual analytics, UoMe takes the stress out of managing payments between friends.</p>
                            <a href="https://github.com/mchacksteam25/mchacks25" target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                    </div>

                    <div className={styles.projectContainer}>
                        <div className={styles.projectImg}>
                            <img src={WAM} alt="Wat-a-Moment"></img>
                        </div>
                        <div className={styles.projectCaption}>
                            <h2>Wat-a-Moment</h2>
                            <div className={styles.dtContainer}>
                                <h3>Python, JavaScript, Flask, HTML/CSS, SQL</h3>
                                <h4>Dec 2024</h4>
                            </div>
                            <p>Wat-a-Moment is a portable photo booth built with a Raspberry Pi and webcam, designed to capture and share memories on the go. Photos are securely stored in the cloud, each tagged with a unique ID for easy retrieval. A web app lets users create accounts, log in, and manage personal or shared photo libraries, making it simple for classmates or groups to access and relive their moments. Compact, connected, and user-friendly, it brings a modern twist to the classic yearbook.</p>
                            <a href="https://github.com/cherrybyproxy/Wat-a-Moment" target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                    </div>

                    <div className={styles.projectContainer}>
                        <div className={styles.projectImg}>
                            <img src={MMC} alt="Math Club Website"></img>
                        </div>
                        <div className={styles.projectCaption}>
                            <h2>MGCI Math Club Website</h2>
                            <div className={styles.dtContainer}>
                                <h3>React JS, HTML/CSS</h3>
                                <h4>June 2024</h4>
                            </div>
                            <p>A website for the MGCI Math Club that acts a hub for events, resources, and community. It features a welcoming homepage with a banner and navigation bar, a carousel to display photos from past events and highlight upcoming activities, and a resources page with lesson slides and short summaries. An “About Us” section introduces the executive team and provides contact details, making it easy for students to get involved and stay connected.</p>
                            <a href="https://github.com/cherrybyproxy/mathclubsitev1" target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                    </div>

                    <div className={styles.projectContainer}>
                        <div className={styles.projectImg}>
                            <img src={BIC} alt="Bad Ice Cream"></img>
                        </div>
                        <div className={styles.projectCaption}>
                            <h2>Adobe Flash Game Re-creation</h2>
                            <div className={styles.dtContainer}>
                                <h3>Java, Git</h3>
                                <h4>Jan 2024</h4>
                            </div>
                            <p>A Java-based re-creation of the 2D multiplayer game Bad Ice Cream. Players can team up or compete while navigating maps, dodging proximity-based enemies, and breaking through obstacles. The game features smooth animations, responsive controls, adjustable audio, and a live scoreboard that updates automatically. Built with object-oriented design, it captures the fun of the original while adding polish for a more engaging gameplay experience.</p>
                            <a href="https://github.com/cherrybyproxy/BadIceCream" target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function ExitButton() {
    const navigate = useNavigate();
    const click = () => {
        navigate('/home');
    }
    return (
        <button onClick={click} className={styles.exitButton}>X</button>
    )
}